import { ConfigProvider } from 'antd';
import * as React from 'react';

export interface ILayoutProps {
  children?: JSX.Element;
  topbar?: JSX.Element;
  sidebar?: JSX.Element;
}

const Layout: React.FC<ILayoutProps> = ({ topbar, children }) => {
  return (
    <ConfigProvider
      select={{
        className:
          '[&_.ant-select-clear]:opacity-100 [&_.ant-select-clear]:wh-[30px] [&_.ant-select-clear]:!right-0 [&_.ant-select-clear]:-translate-y-1/2  [&_.ant-select-clear]:flex  [&_.ant-select-clear]:item-center  [&_.ant-select-clear]:justify-center [&_.ant-select-clear]:m-0 [&_.ant-select-clear]:text-gray-9',
      }}
      theme={{
        components: {
          Segmented: {
            itemSelectedBg: '#2422200A',
            itemSelectedColor: '#242220',
            itemHoverBg: '#2422200A',
            itemColor: 'rgba(28, 31, 79, 0.7)',
            trackBg: 'transparent',
            trackPadding: 2,
          },
        },
      }}
    >
      <div className="base-layout h-full w-full flex flex-col bg-[#F3FAFF] ">
        <div className="layout-topbar empty:hidden w-full flex-grow">{topbar}</div>
        <div className="w-full h-full overflow-hidden">{children}</div>
      </div>
    </ConfigProvider>
  );
};

export default Layout;
